module.exports = __webpack_public_path__ + "img/kiko-hint.1a86770d.png";